import React from 'react';
import PropTypes from 'prop-types';

const DocumentIcon = ({ className }) => {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            xmlns="http://www.w3.org/2000/svg"
            className={`fill-current ${className}`}
            fill="currentColor" // Ensures the color can be changed dynamically
        >
            <path fillRule="evenodd" clipRule="evenodd" d="M2.42378 2.42378C1.88972 2.95784 1.604 3.83465 1.604 5.24984V8.74984C1.604 10.165 1.88972 11.0418 2.42378 11.5759C2.95784 12.11 3.83465 12.3957 5.24984 12.3957H8.74984C10.165 12.3957 11.0418 12.11 11.5759 11.5759C12.11 11.0418 12.3957 10.165 12.3957 8.74984V5.83317C12.3957 5.59155 12.5915 5.39567 12.8332 5.39567C13.0748 5.39567 13.2707 5.59155 13.2707 5.83317V8.74984C13.2707 10.2513 12.9731 11.4162 12.1946 12.1946C11.4162 12.9731 10.2513 13.2707 8.74984 13.2707H5.24984C3.74835 13.2707 2.5835 12.9731 1.80506 12.1946C1.02662 11.4162 0.729004 10.2513 0.729004 8.74984V5.24984C0.729004 3.74835 1.02662 2.5835 1.80506 1.80506C2.5835 1.02662 3.74835 0.729004 5.24984 0.729004H8.1665C8.40813 0.729004 8.604 0.924879 8.604 1.1665C8.604 1.40813 8.40813 1.604 8.1665 1.604H5.24984C3.83465 1.604 2.95784 1.88972 2.42378 2.42378Z" fill="currentColor"/>
            <path fillRule="evenodd" clipRule="evenodd" d="M7.99908 0.762319C8.16256 0.694603 8.35074 0.732033 8.47586 0.857157L13.1425 5.52382C13.2677 5.64895 13.3051 5.83712 13.2374 6.00061C13.1697 6.16409 13.0101 6.27068 12.8332 6.27068H10.4998C9.6006 6.27068 8.86189 6.12646 8.36756 5.63213C7.87323 5.1378 7.729 4.39909 7.729 3.49985V1.16652C7.729 0.989564 7.8356 0.830036 7.99908 0.762319ZM8.604 2.22274V3.49985C8.604 4.35061 8.75144 4.77857 8.98628 5.01341C9.22112 5.24825 9.64907 5.39568 10.4998 5.39568H11.777L8.604 2.22274Z" fill="currentColor"/>
        </svg>

    );
};

DocumentIcon.propTypes = {
    className: PropTypes.string, // Optional: allows passing Tailwind or custom classes
};

DocumentIcon.defaultProps = {
    className: '', // Default to an empty string
};

export default DocumentIcon;